import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './NearestAgency.css';
import Axios from 'axios';
import imagelocation from '../../images/location.png';
import imageMylocation from '../../images/mylocation.png';
import BimeManager from '../../Core/BimeManager';
import { ui } from 'saffroncodejs';
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';



class NearestAgancy extends React.Component {
  myLocLat = 1;
  myLocLong = 1;
  infW = '';
  constructor(props) {

    super(props);
    this.onMarkerClick = this.onMarkerClick.bind(this);
    // this.onMapClicked=this.onMapClicked.bind(this);
    this.getMyLocation();
    this.state = {
      isLoading: true,
      currentLatitude: '',
      currentLongitude: '',
      index: '',
      data: [{ "Code": 99, "Kind": 201, "PersonKind": 47, "Active": true, "State": 1, "Name": "اجرايي مرکز", "Tel": "22258046", "Mobile": null, "Fax": "22923846", "CodePosti": "1911933183", "Email": "Novin99@NovinInsurance.com", "Address": "تهران - بلوار ميرداماد - ميدان مادر (محسني) - خيابان بهروز - ساختمان شماره 11", "WebSiteAddress": null, "BeginDate": "1384/12/15", "EndDate": null, "Degree": 1, "City": "تهران", "Jens": null, "Economic": null, "CompanyCode": null, "SabtNo": null, "DisplayOrder": 1, "Longitude": 51.4427787065506, "Latitude": 35.759328852984716, "Distance": null }]
      ,

      lat: '',
      long: '',
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {}
    };

    this.state.data = [];
    this.getMyLocation = this.getMyLocation.bind(this);
  }
  componentDidMount() {
    this.getMyLocation();


  }
  getMyLocation() {
    navigator.geolocation.getCurrentPosition(function (position) {
      this.setState({
        currentLatitude: position.coords.latitude,

        currentLongitude: position.coords.longitude,

      });
      this.myLocLat = Number(position.coords.latitude);
      this.myLocLong = Number(position.coords.longitude);

      this.loadDetail();
    }.bind(this));


  }
  loadDetail() {
    Axios.get(BimeManager.etelaatshoab + "/Get/?" + BimeManager.makeGetBody({ kind: null, currentLongitude: this.state.currentLongitude, KindArray: ['202', '203', '204', '205', '206', '207'], currentLatitude: this.state.currentLatitude }))

      .then((result) => {
        console.log("result.data : ", JSON.stringify(result.data));

        this.setState({ data: result.data, isLoading: false })

      })
      .catch((error) => { alert(error) })
  }



  onMarkerClick(props, marker) {
    console.log('marker', marker)
    this.infW =
      <div style={{ maxWidth: 'auto', textAlign: 'center', fontFamily: 'BYekan' }}>
        <h6>{marker.title}</h6>
        <p style={{ color: '#b41e8e' }}>{marker.name}</p>

      </div>

    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });
  }

  render() {
    var i = 0;
    return (

      <div>
        <Row>
          <Col sm="12" className="alignRight title">
            <h4>نزدیکترین نمایندگی ها</h4>
          </Col>
        </Row>
        {!this.state.isLoading ? (
          <Container>
            <div className="map_container">
              <Map
                google={this.props.google}
                initialCenter={{
                  lat: this.state.currentLatitude,
                  lng: this.state.currentLongitude
                }}
                icon={{
                  url: imageMylocation,
                }}
                zoom={14}

              >
              <Marker
                          
                          name={'شما اینجایید'}

                          position={{ lat: this.state.currentLatitude, lng: this.state.currentLongitude }}
                          icon={{
                            url: imageMylocation,
                          }}
                          title={'شما اینجایید'}

                />

                {this.state.data.slice(0, 10).map((points) => {
                  return ([
                    <Marker
                      key={i}
                      name={points.Address}

                      position={{ lat: points.Latitude, lng: points.Longitude }}
                      icon={{
                        url: imagelocation,
                      }}
                      title={points.Name}
                      onClick={this.onMarkerClick}

                    />,

                  ]
                  )
                }


                )}
                <InfoWindow
                  marker={this.state.activeMarker}
                  visible={this.state.showingInfoWindow}>
                  {this.infW}
                </InfoWindow>
              </Map>
            </div>


          </Container>) : (<ui.Preloader />)}
      </div>
    );
  }
}
export default GoogleApiWrapper({
  apiKey: "AIzaSyCEq1aaFxPd0t1j_8dTR2VRJeJp4cKKXaY"
})(NearestAgancy)


// WEBPACK FOOTER //
// ./src/components/Namayandegi/NearestAgancy.js